export default function() {
  var backendUrl = "https://";
  if (process.env.NODE_ENV === "development") {
    backendUrl = "http://";
  }
  backendUrl = backendUrl.concat(process.env.VUE_APP_BASE_URL);
  if (process.env.VUE_APP_SERVER_PORT != null) {
    backendUrl = backendUrl.concat(":", process.env.VUE_APP_SERVER_PORT);
  }
  return backendUrl;
}
